import React, { useEffect } from "react";
import { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { useHistory, useParams } from "react-router-dom";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import {
  headerSortingClasses,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from "../../../../../../_metronic/_helpers";
import {
  ConvertToDateCurrentTimeZoneOnlyDate,
  Currency,
  getFromatdate,
  GetRole,
  getTimeZoneOffset,
} from "../../../../../../_metronic/_helpers/GlobalHelpers";
import moment from "moment";
import MasterInvoiceModal from "./MasterInvoiceModal";
import { downloadCSV } from "./CSVExporter";
import { apiCalll } from "../../../../../../_metronic/_helpers/apiHelpers";

const MasterInvoiceHistory = (props) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = JSON.parse(localStorage.getItem("user")).token;
  const [stores, setStores] = useState([]);
  const [search, setSearch] = useState("");
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [isInvoiceLoading, setIsInvoiceLoading] = useState(false);
  const [data, setData] = useState([]);
  // grt id from useParam
  const params = useParams();
  const id = params.id;
  const history = useHistory();
  const [initFilter, setinitFilter] = useState({
    page: 1,
    sizePerPage: 10,
    sortField: "Id",
    sortOrder: "desc",
    totalSize: 10,
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
    ],
  });

  const handleGetTotalInvoiceByDate = (id) => {
    fetch(`${BASE_URL}/PharmacyAdminManagement/GetMasterInvoiceDetails/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      Allow: "GET",
    })
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          setData(data[1]);
          setShowInvoiceModal(true)
        } else if (data[0] === 401) {
          history.push("/logout");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const exportData = async (id, masterInvoiceNumber) => {
      await apiCalll({
        method: "GET",
        link: `/PharmacyAdminManagement/GetOrdersByMasterInvoice?masterInvoiceId=${id}&timezone=${getTimeZoneOffset()}`,
      }).then((data) => {
        if (data?.length > 0 && data[0] === 200) {
          downloadCSV(data[1], `Master-invoice-breakdown-${masterInvoiceNumber}`)
        }
      });
    };


  const columns = [
    {
      dataField: "invoiceNumber",
      text: "Invoice #",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => <b>#{row?.masterInvoiceNumber}</b>,
      headerSortingClasses,
    },
    {
      dataField: "created",
      text: "Created Date",
      headerFormatter: (cellContent, row) => (
        <>
          Created Date
          <OverlayTrigger
            key={"right"}
            placement={"right"}
            overlay={
              <Tooltip id={`tooltip-${"placement"}`}>{getFromatdate()}</Tooltip>
            }
          >
            <span
              style={{ cursor: "pointer" }}
              className="svg-icon menu-icon svg-icon-info"
            >
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")}
              />
            </span>
          </OverlayTrigger>
        </>
      ),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        // format date to dd/mm/yyyy
        <p>
          {!!row.created
            ? ConvertToDateCurrentTimeZoneOnlyDate(row.created)
            : "-"}
        </p>
      ),
      headerSortingClasses,
    },
    {
      dataField: "totalAmount",
      text: "Paid Amount",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <>{row.totalAmount ? Currency(row.totalAmount) : "$0.00"}</>
      ),
      headerSortingClasses,
    },
    {
      dataField: "startDate",
      text: "Pay Period ",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <>
          {row.startDate && moment(row.startDate).format(getFromatdate())}
          {" - "}
          {row.endDate && moment(row.endDate).format(getFromatdate())}
        </>
      ),
      headerSortingClasses,
    },
    GetRole() === "Carrier Admin" && {
      dataField: "pdf",
      text: "Invoice",
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cellContent, row) => (
        <button
          onClick={() => {
            handleGetTotalInvoiceByDate(row?.id);
          }}
          className={`btn btn-secondary font-weight-bolder font-size-sm`}
        >
          Invoice
        </button>
      ),
    },
    {
      dataField: "id",
      text: "Export",
      headerSortingClasses,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
      <button
        onClick={() => {
                exportData(row?.id, row?.masterInvoiceNumber);
        }}
        className="btn btn-success font-weight-bolder font-size-sm"
      >
       Breakdown
      </button>
    ),
    },
  ];

  useEffect(() => {
    setinitFilter({
      page: 1,
      sizePerPage: 10,
      sortField: "Id",
      sortOrder: "desc",
      custom: true,
      totalSize: 100,
      sizePerPageList: [
        { text: "10", value: 10 },
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
    });
  }, []);

  const GetHandlerTableChange = (type, newState) => {
    let values = { ...initFilter };
    if (type === "sort") {
      values.sortField = newState.sortField;
      values.sortOrder = newState.sortOrder;
    }
    if (type === "pagination") {
      values.sizePerPage = newState.sizePerPage;
      values.page = newState.page === undefined ? 1 : newState.page;
    }
    setinitFilter(values);
  };

  const handleGetStore = (filter) => {
    fetch(
      `${BASE_URL}/PharmacyAdminManagement/GetMasterInvoices?pharmacyAdminId=${!props?.isMaster ? "" : id}&pageNumber=${
        filter?.page
      }&pageSize=${filter?.sizePerPage}&search=${search ||
        ""}&sortOrder=${filter?.sortOrder}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        Allow: "GET",
      }
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          setStores(data[1]?.masterInvoices);
          props.setPagination(data[1]?.pagination);
        } else if (data[0] === 401) {
          history.push("/logout");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      if (initFilter || props?.search) {
        handleGetStore(initFilter);
      } else {
        handleGetStore(initFilter);
      }
    }, 500);
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [initFilter, search]);

  const paginationOptions = {
    custom: true,
    totalSize: props?.pagination?.totalItemCount || 0,
    sizePerPageList: initFilter?.sizePerPageList || [],
    sizePerPage: props?.pagination?.pageSize || 10,
    page: props?.pagination?.pageNumber || 1,
  };

  return (
    <>
    <div className="row mb-7">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            name="search"
            placeholder="Search"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <small className="form-text text-muted">
            <b>Search</b> in all fields
          </small>
        </div>
        </div>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination paginationProps={paginationProps}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="orderId"
                data={stores || []}
                columns={columns}
                defaultSorted={[{ dataField: "Created", order: "desc" }]}
                onTableChange={GetHandlerTableChange}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={stores || []} />
                <NoRecordsFoundMessage entities={stores || []} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>

      {showInvoiceModal && (
        <MasterInvoiceModal
          showInvoiceModal={showInvoiceModal}
          setShowInvoiceModal={setShowInvoiceModal}
          data={data}
          ids={[]}
          isInvoiceLoading={isInvoiceLoading}
        />
      )}
    </>
  );
};

export default MasterInvoiceHistory;
